// @flow
import React from 'react'
import styled from 'styled-components'
import colors from '../../../../styles/colors'
import theme from '../../../../styles/theme'
import MarketList from '../../../../components/MarketList'

const Alert = styled.div`
  padding: 15px;
  margin-bottom: 1rem;
  border-radius: 4px;
  color: ${theme.warning.darken(0.5)};
  background: ${theme.warning.lighten(0.6)};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`

const NoResults = () => (
  <div style={{ marginBottom: '2rem' }}>
    <div className="container">
      <Alert>
        <span
          className="fa fa-exclamation-triangle"
          style={{ marginRight: '8px', color: colors.warning }}
        />
        <b style={{ marginRight: '4px' }}>No Search Results Yet</b>
        <span>
          Please enter a city or zip code in the bar above, or select one of our
          market areas below.
        </span>
      </Alert>
      <MarketList />
    </div>
  </div>
)

export default NoResults



// WEBPACK FOOTER //
// ./src/views/Search/components/NoResults/index.js